<template>
  <div class="home">
    <SiteHeader/>
    <div class="home__hero">
      <div class="container">
        <h1><strong>Patenting Portland.</strong> Hire and retain licensed patent attorneys to secure &ldquo;patent pending&rdquo; status for your invention.</h1>
        <h2>PortlandPatent.com provides a collaborative patent filing process for inventors seeking the assistance of licensed patent attorneys to obtain &ldquo;patent pending&rdquo; status for their invention before the U.S. Patent and Trademark Office (&ldquo;USPTO&rdquo;). </h2>
      </div>
    </div>
    <div class="home__main">
      <div class="container">
        <div class="home__main__blurb">
          <span class="white block">
            <h3>Why choose a provisional patent application?</h3>
            <p>It is recommended that inventors avoid discussing, selling, or even using their inventions in public prior to documenting their invention with the U.S. Patent and Trademark Office. A provisional application is a lower-cost mechanism by which to secure a legal &ldquo;priority date&rdquo; and &ldquo;patent pending&rdquo; status for your invention. Once &ldquo;patent pending,&rdquo; inventors may discuss their inventions in public or with investors, etc., without the risk of losing patent rights. Note, however, that all provisional patents expire one year after filing.</p>
          </span>
        </div>
        <div class="home__main__blurb">
          <span class="white block">
            <h3>Faster, lower-cost, earlier &ldquo;patent pending&rdquo; status:</h3>
            <p>A formal non-provisional patent application is required to ultimately secure a U.S. Patent. However, non-provisional patents are more costly, complex, and time-consuming. Depending on where your invention is in the process, inventors may wish to initially file a &ldquo;provisional&rdquo; patent application with the U.S. Patent and Trademark Office to document their invention. A provisional application takes days versus months, costs significantly less, and locks in your &ldquo;patent pending&rdquo; status with the USPTO much earlier than is feasible with a full-fledged &ldquo;non-provisional U.S. Utility Patent Application.&rdquo; Note, however, that a provisional application must be converted to a &ldquo;non-provisional&rdquo; patent application within 1-year of the filing date if a formal U.S. Patent is to be pursued.</p>
          </span>
        </div>
        <div class="home__main__blurb">
          <span class="white block">
            <h3>Buying time</h3>
            <p>Many inventors and companies starting out need more time to develop their products and build their business. In order to do that, they may need to share information about their invention with others. However, discussing your invention with others prior to securing &ldquo;patent pending&rdquo; status puts you at risk for having others potentially claim credit for your invention as their own. A provisional application is a great option to secure protection for your invention while you do further research, marketing, and product development, or if you are looking for a more immediate and cost-effective alternative to a full-fledged (non-provisional) patent application.</p>
          </span>
        </div>
        <div class="home__main__blurb">
          <span class="white block">
            <h3>What happens after I file a provisional patent application?</h3>
            <p>Provisional patent applications become part of your documentation and patent record with the United States Patent &amp; Trademark Office (USPTO) after they are filed, at which point you are legally entitled to identify and label your invention as &ldquo;Patent Pending.&rdquo; Note, however, that all provisional applications expire after one year. They are never examined by the USPTO. They are never published. They cannot ever become an issued U.S. Patent. Rather, inventors must file for a &ldquo;non-provisional&rdquo; patent application with a claim of priority to the provisional application before the one year deadline expires if they wish to move their case forward with the USPTO.</p>
          </span>
        </div>
        <div class="home__main__blurb">
          <span class="white block">
            <h3>What if I want a formal (non-provisional) patent, i.e. a patent that can actually issue?</h3>
            <p>From the date you file a provisional patent application, you have up to one year to file a formal (e.g., a &ldquo;non-provisional U.S. Utility&rdquo;) patent application that will be examined by the USPTO and has a chance of being issued as a U.S. Patent over a subsequent patent examination process that spans a period of typically 2.5 to 5 years and costs significantly more. When you are ready, we are able to help with the process of filing a non-provisional patent application as well. Also keep in mind that you have the option to go straight to filing a formal non-provisional patent application, thus entirely saving the time and cost associated with the provisional patent application. Contact us for more information. </p>
          </span>
        </div>
        <div class="home__main__blurb">
          <span class="white block">
            <h3>Cost-effective and efficient patent service.</h3>
            <p>PortlandPatent.com's innovative web-portal allows inventors to expedite the patent submission process while also benefiting from one-on-one guidance and consultation with a Registered U.S. Patent Attorney. We leverage automation to decrease the cost to you while increasing efficiency of communication and providing transparency of documents and feedback at your fingertips. PortlandPatent.com offers you a more time-efficient solution than attempting to prepare and file a provisional patent application on your own (e.g., as a pro se patent applicant); or having to make multiple visits to your patent attorney’s offices. PortlandPatent.com also offers you a more cost-effective solution than what we are able to provide through our in-person / in-office services through the use of our digital web-portal and on-line platform.</p>
          </span>
        </div>
        <div class="home__main__blurb">
          <span class="white block">
            <h3>Why choose us?</h3>
            <p>We are not an online law firm! Our licensed patent attorneys practice law and work full-time at our downtown offices in Portland, Oregon and our intellectual property law attorneys have more than 40 years of collective experience. We will answer any questions that you have during a private 30-minute in-person, telephone, or video consultation included with all packages that we sell. Next, the web-portal guides you through the process of documenting your invention for review by the attorney who will then prepare a provisional patent application for your review and approval. We are also responsive to your feedback and questions throughout the process. Once you approve of the draft provisional application, we handle 100% of the filing procedures and costs with the United States Patent &amp; Trademark Office to secure &ldquo;patent pending&rdquo; status on your behalf.</p>
          </span>
        </div>
        <div class="home__main__blurb">
          <span class="white block">
            <h3>Don’t go it alone!</h3>
            <p>If you are not aware, you are fully entitled to prepare and file a provisional application with the U.S. Patent and Trademark Office (USPTO) on your own, as a &ldquo;pro se&rdquo; patent applicant. However, we obviously advise against doing so. PortlandPatent.com is different than our on-line competitors that offer &ldquo;guidance,&rdquo; help, tips, books, and general support, but will never actually represent your interests in a legal capacity. Rather, we are fully licensed and experienced patent attorneys with deep knowledge about how to best present your invention to the USPTO. Purchasing a package from PortlandPatent.com means that you actually hire and retain a licensed patent attorney as your legal counsel. You do not file your provisional &ldquo;pro se" and you are not alone in the process. </p>
          </span>
        </div>
        <div class="home__main__blurb">
          <span class="white block">
            <h3>Summary </h3>
            <p>PortlandPatent.com gives you the opportunity to take control of presenting your invention through the submission of your written information about your idea as well as drawings and figures to our Portland based law firm attorneys who will develop your materials into a strong provisional patent application to serve as a foundation for your future intellectual property needs. All through a convenient and efficient on-line portal that guides you through the process while still allowing you to interact directly with our attorneys.</p>
          </span>
        </div>
        <div class="home__main__blurb">
          <span class="block">
            <h3>Ready to get started?</h3>
            <p>See our packages and pricing by clicking the button below.</p>
            <br/><br/>
            <p>
              <router-link class="btn" to="/packages">Get Started</router-link>
            </p>
          </span>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader'
import Footer from '@/components/Footer'

export default {
  name: 'Home',
  components: {
    SiteHeader,
    Footer
  }
}
</script>

<style scoped lang="scss">
.home {
  .container {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }
  &__hero {
    background-color: $primary;
    border-bottom-left-radius: 200px;
    background: linear-gradient(152deg, #4687c5, #37a7c0);
    .container {
      margin: 0 auto;
      max-width: 1060px;
      padding: 80px 40px 120px 40px;
      text-align: center;
      @media($xs-down) {
        padding-left: 20px;
        padding-right: 20px;
      }

      h1 {
        color: white;
        font-family: Raleway, sans-serif;
        font-weight: 300;
        margin-bottom: 40px;
        line-height: 1.3;
        strong {
          font-weight: 700;
        }
      }
      h2 {
        color: white;
        font-size: 16px;
        font-family: Raleway, sans-serif;
        font-weight: 500;
        line-height: 2;
        max-width: 680px;
        margin: 0 auto;
      }
    }
  }
  &__main {
    padding: 80px 40px;
    @media($sm-down) {
      padding: 40px;
    }
    @media($xs-down) {
      padding: 20px;
    }
    .container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 50px;
      @media($sm-down) {
        display: block;
      }
    }
    &__blurb {
      text-align: left;
      display: flex;
      flex-direction: column;
      @media($sm-down) {
        margin-bottom: 40px;
      }
      .block {
        padding: 40px;
        display: block;
        flex: 1;
        @media($xs-down) {
          padding: 20px;
        }
        &.white {
          background-color: white;

        }
      }
      p {
        line-height: 2;
      }
      a {
        @include btn-primary;
        font-size: 1.5em;
      }
    }
  }
}
/deep/ .footer {
  border-top-right-radius: 200px;
}
</style>